import React from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";
import ExploreAppsTop from "./explore_apps/ExploreAppsTop";
import ExploreAppsList from "./explore_apps/ExploreAppsList";

function PageNotFound() {
  return (
    <div>
      {/*Add title and metadata */}
      <title>Change Password</title>
      <meta name="robots" content="noindex"></meta>

      {/*navbar*/}
      <NavBar />
      {/* Page not found text */}
      <div className="container text-center">
        <label
          className="p-3"
          style={{
            marginTop: "8rem",
          }}
        >
          <h1 className="display-3 text-center">404 Page Not Found</h1>
        </label>
      </div>
      {/* Exlore Apps Top */}
      <ExploreAppsTop />
      {/* App List Grid */}
      <ExploreAppsList />
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default PageNotFound;
